// assets
import DashboardOutlined from '@ant-design/icons/DashboardOutlined';
import TeamOutlined from '@ant-design/icons/TeamOutlined';
import UserOutlined from '@ant-design/icons/UserOutlined';
import CalendarOutlined from '@ant-design/icons/CalendarOutlined';
import CheckCircleOutlined from '@ant-design/icons/CheckCircleOutlined';
import SettingOutlined from '@ant-design/icons/SettingOutlined';
import LineChartOutlined from '@ant-design/icons/LineChartOutlined';
import BookOutlined from '@ant-design/icons/BookOutlined';
import PictureOutlined from '@ant-design/icons/PictureOutlined';
import FormOutlined from '@ant-design/icons/FormOutlined';

// icons
const icons = {
  DashboardOutlined,
  TeamOutlined,
  UserOutlined,
  CalendarOutlined,
  CheckCircleOutlined,
  SettingOutlined,
  LineChartOutlined,
  BookOutlined,
  PictureOutlined,
  FormOutlined
};

// ==============================|| MENU ITEMS - SUPERVISOR ||============================== //

// `catalogueCode` ties an item to the specific Features and Pages PAGE it shows
// (rbac_app_page.code), matched by CODE rather than URL because the same screen is
// reached at a different, role-prefixed URL for each role (this menu's
// /supervisor/my-calendar vs the catalogue's join) so a URL match misses it. The page
// code — not the feature code — is used so switching off a single page hides it; the
// backend also reports every page of a switched-off FEATURE as disabled, so a
// feature-level switch is covered by the same code too. See catalogueVisibility.js.
const supervisor = {
  id: 'group-supervisor',
  title: 'Supervisor',
  icon: icons.TeamOutlined,
  type: 'group',
  children: [
    {
      id: 'supervisor-dashboard',
      title: 'Dashboard',
      type: 'item',
      url: '/supervisor/dashboard',
      icon: icons.DashboardOutlined,
      breadcrumbs: false,
      catalogueCode: 'supervisor_dashboard'
    },
    {
      id: 'supervisor-my-calendar',
      title: 'Calendar',
      type: 'item',
      url: '/supervisor/my-calendar',
      icon: icons.CalendarOutlined,
      breadcrumbs: false,
      catalogueCode: 'my_calendar'
    },
    {
      id: 'supervisor-child',
      title: 'Child',
      type: 'item',
      url: '/supervisor/child',
      icon: icons.UserOutlined,
      breadcrumbs: false,
      catalogueCode: 'child_directory'
    },
    {
      id: 'supervisor-therapists',
      title: 'Therapists',
      type: 'item',
      url: '/supervisor/therapists',
      icon: icons.TeamOutlined,
      breadcrumbs: false,
      catalogueCode: 'therapist_directory'
    },
    {
      id: 'supervisor-skills',
      title: 'Skills Repository',
      type: 'item',
      url: '/supervisor/skills',
      icon: icons.BookOutlined,
      breadcrumbs: false,
      catalogueCode: 'skill_repository_page'
    },
    {
      id: 'supervisor-materials',
      title: 'Material Repository',
      type: 'item',
      url: '/supervisor/materials',
      icon: icons.PictureOutlined,
      breadcrumbs: false,
      catalogueCode: 'material_repository_page'
    },
    // {
    //   id: 'supervisor-form-builder',
    //   title: 'Form Builder',
    //   type: 'item',
    //   url: '/supervisor/form-builder',
    //   icon: icons.FormOutlined,
    //   breadcrumbs: false,
    //   desktopOnly: true
    // },
    {
      id: 'supervisor-reports',
      title: 'Reports',
      type: 'item',
      url: '/supervisor/reports',
      icon: icons.LineChartOutlined,
      breadcrumbs: false,
      catalogueCode: 'supervisor_reports'
    },
    {
      id: 'supervisor-settings',
      title: 'Settings',
      type: 'item',
      url: '/supervisor/settings',
      icon: icons.SettingOutlined,
      breadcrumbs: false,
      // The FEATURE code, not a page code, unlike its siblings above. This item opens
      // the whole Settings screen and the pages beneath it are its TABS, none of which
      // appear in the sidebar — so the thing that should hide this item is the feature
      // switch, not one tab. Both gates read feature codes: a switched-off feature is
      // reported in disabled_features, and a granted feature puts its code in
      // granted_codes.
      catalogueCode: 'clinical_settings'
    }
  ]
};

export default supervisor;
